import api, { unwrap } from './client';

// Décompte TVA — CALCULÉ PAR LE SERVEUR (moteur migré du JavaScript le
// 2026-08-21). Retourne courus (billed / déductibles / net), échéancier
// calculé, versements effectifs (saisies incluses), remboursements, solde dû
// et la série {accrual, cash} que le bilan consomme en live.
// Les saisies passent toujours par l'hypothèse `vat_plan` (forecast-assumptions).
export const getVatPlan = (tenantId, year) =>
  unwrap(api.get(`/financials/vat-plan/${tenantId}`, { params: { year } }));

// Libellés de périodicité — affichage seul (le calcul vit au serveur).
export const VAT_PERIOD_LBL = { month: 'mensuel', quarter: 'trimestriel', semester: 'semestriel', year: 'annuel' };
